import { dataExclamationTriangleSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconExclamationTriangleSolid = /*#__PURE__*/createIcon(dataExclamationTriangleSolid)
export default IconExclamationTriangleSolid
